<div
  *transloco="let t; read: 'widget-group-chooser'"
  class="xi-modal__container widget-group-chooser__container"
>
  <h2 class="xi-modal__title widget-group-chooser__title">
    {{ t('title') }}
  </h2>

  <form [formGroup]="form" class="xi-modal__content">
    <xi-dropdown
      formControlName="id"
      [label]="t('widget-group')"
      [placeholder]="t('select-widget-group')"
      [stretch]="true"
      [data]="ds"
    ></xi-dropdown>
  </form>

  <div class="xi-modal__actions widget-group-chooser__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button [text]="t('add')" [disabled]="form.invalid" (onClick)="onAdd()">
    </xi-default-button>
  </div>
</div>
